/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/social-export-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { DeleteUploadMutationResponse, DeleteUploadPathParams } from "../models/DeleteUpload";

export function getDeleteUploadUrl(id: DeleteUploadPathParams["id"]) {
  const res = { method: 'DELETE', url: `/upload/${id}` as const }
  return res
}

/**
 * @summary Delete video from platform
 * {@link /upload/:id}
 */
export async function deleteUpload(id: DeleteUploadPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DeleteUploadMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getDeleteUploadUrl(id).url.toString(), ... requestConfig })
  return res.data
}